module.exports = __webpack_public_path__ + "img/lsjn3.c88565f4.jpg";